import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import { logoutTenant } from '../../store/redux/slices/tenantAuthSlice';
import EnterpriseIcon from '../../assests/images/EnterpriseIcon.png'
import {
  HomeIcon,
  ListenerIcon,
  SettingIcon,
  NotificationIcon,
  LogoutIcon,
  UserIcon,
  ChatterTrackerIcon,
  sentinelHub_icon,
  AlertIcon2,
  CompetitiveInteligence,
  TopicListIcon,
  SentinalHubIcon,
  CompetitiveIcon,
  SentinalIcon,
} from '../../Common/SvgIcon/CommonSvgIcons';
import UserProfileIcon from '../../Common/Avatar/Avatar.jsx';
import {
  LogoutPopUP,
  Triangle,
} from '../../Common/CommonStyledElement/CommonStyledElement';
import { activeTopicList, resetFlagFunc, searchTextEmpty, setFilterPayload, topicPreviewEmpty } from '../../store/redux/slices/topicSlice.js';
import { updateShowSideBar } from '../../store/redux/slices/competitiveIntelligenceSlice.js';
import { emptyCustomAnalysis, emptyCustomAnalysisResult, updateSearchQuery, updateSelectedDraft } from '../../store/redux/slices/chatterSlice.js';
import { persistor } from '../../store/store.js';
import { batch } from 'react-redux';

import Competitive from '../../assests/images/Competitive.png';
import Sentinal from '../../assests/images/Sentinal.png';
import { getConsoleDashBoard } from '../../store/redux/slices/homePageSlice.js';
import { IconBase } from 'react-icons';

const Wrapper = styled.div`
  min-width:1000px;
  height: 70px;
  // background: #353cf7;

  display: grid;
  // grid-template-columns: 10% 10% 60% 20%;
  // grid-template-columns: 15% 78% 7%;
  grid-template-columns:15% 75% 1px 10%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;

  & > * {
    display: flex;
    gap: 12px;
    padding: 10px;
  }

  // Style for BA LOGO
  & > :nth-child(1) {
    margin-left: 5px;
    img {
      width: 50px;
      cursor: pointer;
    }
  }
  // & > :nth-child(2) {
  //   margin-left: 5px;
  //   img {
  //     width: 50px;
  //     cursor: pointer;
  //   }
  // }

  // Style for Tabs
  & > :nth-child(2) {
    & > * {
      // width: 18px;
      // height: 18px;
      // padding: 10px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // background: rgba(255, 255, 255, 0.6);
      // border-radius: 50%;
      // cursor: pointer;
      display: flex;
      gap: 5px;
      padding: 0px 10px;
      height: 55px;
      
      align-items: center;

      // & svg {
      //   width: 17px;
      //   height: 17px;
      // }
    }
  }
    & > :nth-child(3) {
    width:1px;
    background:white;
    padding:0px;
    height:70%;
    }
  & > :nth-child(4) {
    justify-content: end;
    align-items: center;
    margin-right: 20px;

    // Alert Icon
    // & > :nth-child(2) {
    //   width: 14px;
    //   height: 14px;
    //   padding: 13px;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   background: #fff;
    //   cursor: pointer;
    //   border-radius: 50%;
    //   position: relative;

    //   & > span {
    //     position: absolute;
    //     top: -4px;
    //     right: -4px;
    //     background: #fc6758;
    //     width: 18px;
    //     height: 18px;
    //     font-size: 12px;
    //     border-radius: 50%;
    //     color: #fff;
    //   }
    // }

    // Notification Icon
    // & > :nth-child(3) {
    //   width: 14px;
    //   height: 14px;
    //   padding: 13px;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   background: #fff;
    //   cursor: pointer;
    //   border-radius: 50%;
    //   position: relative;

      // & > span {
      //   position: absolute;
      //   top: -4px;
      //   right: -4px;
      //   background: #fc6758;
      //   width: 18px;
      //   height: 18px;
      //   font-size: 12px;
      //   border-radius: 50%;
      //   color: #fff;
      // }
    // }
  }

  // Style for active tab navigation
  .activeTab {
    background: #fff;
    width: auto;
    border-radius: 50px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 15px;
    font-weight: 600;
    transition: all 50ms linear;
    font-family: 'Inter';
    & svg {
      width: 26px;
      height: 26px;
    }
  }

  .alertActiveTab {
    
  }
`;

const FlexTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 55px;

  & > .svgclassDiv{
    width: 18px;
    height: 18px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 50%;
    cursor: pointer;
    & svg {
      width: 24px;
      height: 24px;
    }
  
  
  }
    .activeTab {
    width:22px;
    background: #fff;
    border-radius: 50px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    transition: all 50ms linear;
    font-family: 'Inter';
    // & svg {
    //   width: 26px;
    // }
  }
    & > .title {
    font-size: 12px;
    color: white;
    font-weight: 500;
    font-family: inherit;
    }

  
`;

const AlertStyle = styled.div`

      width: 18px;
      height: 18px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${({ isActive }) =>
    isActive ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.6)'};
      border-radius: 50%;
      cursor: pointer;

`;

function Header2() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [logoutPopupVisible, setLogoutPopupVisible] = useState(false);
  const popUpRef = useRef(null);
  const dispatch = useDispatch();
  const { getTenantLogoData } = useSelector((state) => state.tenantSetting);
  
    const { topicPreviewDataLoader} = useSelector((state) => state.topicBuilder) || {};
  let url = location.pathname.split('/')[1]; //to get the url

  //to hide logout popup on outside click
  useEffect(() => {
    
    const handleOutsideClick = (event) => {
      if (popUpRef.current && !popUpRef.current.contains(event.target)) {
        setLogoutPopupVisible(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);


  useEffect(() => {
    let fullPath = location.pathname;

    if (fullPath.startsWith('/homepage')) setActiveTab(1);
    else if (fullPath.startsWith('/topic')) setActiveTab(2);
    else if (fullPath.startsWith('/chatter')) setActiveTab(3);
    else if (fullPath.startsWith('/setting')) setActiveTab(4);
    else if (fullPath.startsWith('/sentinelHub')) setActiveTab(5);
    else if (fullPath.startsWith('/alert')) setActiveTab(6);
    else if (fullPath.startsWith('/competitiveIntelligence')) setActiveTab(7);
    else if (fullPath.startsWith('/enterprise')) setActiveTab(8);
  }, [url]);

  const { personalDetailsData, previewTheme } = useSelector((state) => state.tenantSetting) || {};
  const themeData = previewTheme || personalDetailsData;
  
  // If there is no token then logout user
  const user = JSON.parse(sessionStorage.getItem('brandUser'))?.user_details;
  // useEffect(() => {
  //   if (!user || user === null) {
  //     navigate('/login');
  //   }
  // }, [url]);

  //Show PopUp on user icon click
  const handleUserIconClick = () => {

    dispatch(activeTopicList());
    setLogoutPopupVisible(!logoutPopupVisible);
  };

  const tabList = [
    {
      id: 1,
      link: '/homepage/dashboard',
      title: 'Command Center',
      icon: HomeIcon,
      testId: 'item-0',
    },
    {
      id: 2,
      link: '/topic/home',
      title: 'Topic Listening',
      // icon: ListenerIcon,
      icon: TopicListIcon,
      testId: 'item-1',
    },
    {
      id: 3,
      link: '/chatter/home',
      title: 'Chatter Tracker',
      icon: ChatterTrackerIcon,
      testId: 'item-2',
    },
    // {
    //   id: 8,
    //   link: '/enterprise/home',
    //   title: 'Enterprise',
    //   icon: <img src={EnterpriseIcon} style={{width:'20px',height:'20px'}} />,
    //   testId: 'item-6',
    // },
    {
      id: 7,
      link: '/competitiveIntelligence/home',
      title: 'Competitive Intelligence',
      icon: CompetitiveIcon,
      testId: 'item-5',
    },
    {
      id: 5,
      link: '/sentinelHub',
      title: 'Sentinel Hub',
      // icon: sentinelHub_icon,
      // icon:SentinalHubIcon,
      icon: SentinalIcon,
      testId: 'item-4',
    },
    {
      id: 4,
      link: '/setting/personal',
      title: 'Settings',
      icon: SettingIcon,
      testId: 'item-3',
    },
    {
      id: 6,
      link: '/alert',
      title: 'Alert Configuration',
      icon: AlertIcon2,
      testId: 'item-3',
    },
  ];

  const selectTabHandler = (tab = 1, link = '/') => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    if (tab == 1) {
      dispatch(getConsoleDashBoard());
    }
    setActiveTab(tab);
    navigate(link);

    batch(() => {

      dispatch(setFilterPayload({}));
      dispatch(updateShowSideBar(''))
      dispatch(searchTextEmpty())

      dispatch(resetFlagFunc(true))


      dispatch(updateSearchQuery(''));
      dispatch(emptyCustomAnalysis());
      dispatch(emptyCustomAnalysisResult());
      dispatch(updateSelectedDraft(null));
      dispatch(searchTextEmpty());
      dispatch(topicPreviewEmpty());

      dispatch(activeTopicList());
    })
  };

  const navigateToSetting = () => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    dispatch(activeTopicList());
    navigate('/setting/personal');
    setLogoutPopupVisible(!logoutPopupVisible);
    dispatch(resetFlagFunc(true))
  };

  const logoutHandler = () => {

    // dispatch(activeTopicList());
    persistor.purge();
    sessionStorage.removeItem('persist:root');

    setLogoutPopupVisible(!logoutPopupVisible);
    dispatch(logoutTenant());
    navigate('/login');
    window.location.reload();
  };

  const handleAlertIconClick = () => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    dispatch(activeTopicList());
    setActiveTab(6);
    navigate('/alert')
  }
  const handeIconClick = () => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    dispatch(activeTopicList());
    navigate('/login')
  }

  return (
    <Wrapper ref={popUpRef} style={{
      
  background: ((themeData?.is_custom == 'custom') && (themeData?.gradient == true))
  ? `linear-gradient(172.47deg, ${themeData?.sys_navigation || '#073358'} -63.2%, ${themeData?.selected_items || '#026661'} -17.55%, ${themeData?.sidebar_navigation || '#026661'} 54.92%, ${themeData?.heading_accent || '#A1D823'} 105.06%)` :  
  (themeData?.is_custom == 'custom') ? `${themeData?.sys_navigation || '#073358'}` : 
  "linear-gradient(172.47deg, #073358 -63.2%, #0C3F89 -17.55%, #026661 54.92%, #98E586 105.06%, #A1D823 116.76%)"
    }}>
      <div style={{ padding: '6px' }}>
        <div onClick={() => handeIconClick()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={`${process.env.PUBLIC_URL}/images/BrandAstra_BA_White.png`}
            alt='logoImg'
            style={{
              width: '45px',
              height: '20px'
            }}
          />
        </div>
        {
          personalDetailsData?.tenant_logo && personalDetailsData?.tenant_logo != 'string' ?
            <div style={{ background: 'white', width: '1px' }}></div>
            :

            <div style={{ background: 'none', width: '1px' }}></div>
        }
        <div onClick={() => handeIconClick()} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
          {
            personalDetailsData?.tenant_logo && personalDetailsData?.tenant_logo != 'string' ?
              <img
                src={`${personalDetailsData?.tenant_logo || ''}`}
                alt='logoImg'
                style={{
                  maxWidth: '160px',
                  height: '50px',
                  objectFit: 'contain'
                }}
              />
              :
              <></>
          }

        </div>
      </div>

      <div className='tabContainer' style={{padding:'5px 10px',display:'grid',gridTemplateColumns:'135px 136px 126px 165px 109px 115px 135px',gap:'1px'}}>
        {tabList.map(({ id, link, title, icon, testId }) => (
          <FlexTabContainer>
          {/* // <Tooltip title={activeTab === id ? '' : title}> */}
              <div
                className={activeTab === id ? 'activeTab svgclassDiv' : 'svgclassDiv'}
                key={id}
                onClick={() => title == 'Alert Configuration' ? handleAlertIconClick() : selectTabHandler(id, link)}
                data-testid={testId}
              >
                {
                  // title === 'Competitive Intelligence' || title === 'Sentinel Hub' ? (
                  //   <img src={icon} alt={title} 
                  //   style={{ 
                  //     width: '23px',
                  //     height: '23px', 
                  //     display: 'flex',
                  //     alignItems: 'center',    
                  //     justifyContent: 'center',
                  //     margin: '0px' }} />
                  // ) :
                  (
                    icon
                  )}
                {/* {activeTab === id && title} */}
              </div>
              <div className='title' style={{fontWeight:activeTab === id ? '600': '400'}}>{title}</div>
          {/* // </Tooltip> */}
          </FlexTabContainer>
        ))}
      </div>
      <div></div>
      <div>
        {/* <AlertStyle isActive={activeTab === 6} onClick={handleAlertIconClick}>
          <Tooltip title={'Alert Configuration'}>
            <div
              key={'alert'}
              onClick={handleAlertIconClick}
              data-testid={'alert'}
            >

            </div>
            {AlertIcon2}
          </Tooltip>

        </AlertStyle> */}
        {/* <div>
          {NotificationIcon}
          <span>1</span>
        </div> */}
        <div onClick={handleUserIconClick} data-testid={'logout'}>
          <UserProfileIcon
            picture={personalDetailsData?.profile_pic || ''}
            userName={personalDetailsData?.user_name || ''}
            bgColor={personalDetailsData?.role_id === 100 ? 'rgb(7 82 118)' : 'rgb(7 82 118)'}
          />
        </div>
        {logoutPopupVisible && (
          <LogoutPopUP>
            <div className='userPic'>
              <UserProfileIcon
                picture={personalDetailsData?.profile_pic || ''}
                userName={personalDetailsData?.user_name || ''}
                bgColor={personalDetailsData?.role_id === 100 ? 'rgb(7 82 118)' : 'rgb(7 82 118)'}
              />
            </div>
            <div className='userName'>{personalDetailsData?.user_name}</div>
            <div>{personalDetailsData?.email_id}</div>
            <div className='line'></div>
            <div className='myProfile_logout' onClick={navigateToSetting}>
              {UserIcon}
              My Profile
            </div>
            <div className='myProfile_logout' onClick={logoutHandler}>
              {LogoutIcon}
              Logout
            </div>
          </LogoutPopUP>
        )}
        {logoutPopupVisible && <Triangle />}
      </div>
    </Wrapper>
  );
}

export default Header2;